import { computed } from 'vue';

export interface Props {
    title?: string;
    titleColor?: string;
    prominent?: boolean;
    description?: string;
    loading?: boolean;
    showThankyou?: boolean;
    showHasBooking?: boolean;
}

export function setupBookingCard(props: Props) {
    const titleCssClasses = computed(() => [
        `${props.titleColor ? `text-${props.titleColor}` : ''}`,
        `${props.prominent ? 'text-h4 text-center' : 'text-h5 font-weight-bold'}`
    ]);
    const textCssClasses = computed(() => [`${props.prominent ? 'text-center' : ''}`]);

    return {
        titleCssClasses,
        textCssClasses
    };
}
